export const VETSTAT_UI = {
  datasetBuilder: {
    table41Title: "Dataset Builder - Table 4.1 (2022)",
    table41Description:
      "Visualize aggregated VetStat data (kg active substance). Rows are animal species (supergroup) with associated age groups; choose which New_UK_EMA columns and which years to display.",
    table41RowLabel: "Select animal species (rows)",
    table41ColLabel: "Select New_UK_EMA (columns)",

    annualTrendTitle: "Dataset Builder - Annual trend by age group",
    annualTrendDescription:
      "Visualize data by age group over time. Select one or more age groups to see their annual trend.",
    annualTrendRowLabel: "Select age groups",
    annualTrendColLabel: "Select New_UK_EMA (columns)",

    exportConfigurationTitle: "Export configuration",
    settings: "Settings",
    resetSettings: "Reset settings",
    cancel: "Cancel",

    selectSpeciesFilter: "Select animal species (filter)",
    selectAgeGroupFilter: "Select age group (filter)",
    noneSelected: "None selected",

    selectYearsOptional: "Select years (optional)",
    aggregationYear: "Aggregation year",
    allSelectedYears: "All selected years",

    loadingData: "Loading data...",

    layout: "Layout",
    layoutFitOriginal: "Fit to content (Original)",
    layoutA4Full: "A4 Full width",
    layoutA4Half: "A4 Half width",

    exportCsv: "Export CSV",
    exportImagePdf: "Export image/PDF",

    csvHeaderAgeGroup: "Age group",
    csvHeaderYear: "Year",

    selectRowsAndColsToShow:
      "Select at least one row and at least one column to display the table.",

    imageExportFailed: "Could not generate image.",
    pdfExportFailed: "Could not generate PDF.",
    pivotFetchFailed: "Could not fetch pivot data",
  },

  chartExport: {
    defaultChartTitleSuffix: "chart",
    defaultChartSubtitle: "Annual consumption in kg active substance",

    exportConfigTitle: "Export configuration",
    exportChart: "Export chart",
    exportAs: "Export as",

    downloadingDataset: "Downloading dataset...",
    downloadWithFilters: "Download the dataset with the current filters",
    downloading: "Downloading...",
    downloadDataset: "Download dataset",

    fetchDatasetFailed: "Could not fetch dataset",
    downloadErrorGeneric: "An error occurred during download.",

    exportDisabledReasonDefault: "Generate a chart before exporting.",
    exportChartTooltip: "Export the displayed chart as an image or PDF",

    noDataToDisplay: "No data to display",

    settings: "Settings",
    resetSettings: "Reset settings",

    title: "Title",
    subtitle: "Subtitle",
    source: "Source",
    yearRotation: "Year label rotation",
    yAxisInterval: "Y-axis interval",
    skipEveryOtherYear: "Skip every other year",
    width: "Width",
    halfPage: "Half page (8.75cm)",
    fullWidth: "Full width (18cm)",

    pdfIncludesFilters:
      "The PDF export includes the selected filters and metadata.",

    showLegend: "Show legend",
    showGrid: "Show grid",
  },
} as const;
